export const promptExamples = [
  {
    title: "Hindi Podcast Comedy Clip",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Podcast scene. A man says, 'कमाने पे आऊँ तो मैं अंबानी को पीछे छोड़ दूँ, पर खाली हाथ जाना है तो इतना झंझट क्यों करूँ.' Tone is playful and confident."
    }
  },
  {
    title: "Lebanese Accent Comedy",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Interview scene. The interviewer asks, 'How responsible are you?' The man replies in a Lebanese accent, 'I am very much responsible. Anything breaks, I am responsible, yes.' Audience laughs."
    }
  },
  {
    title: "Hindi Classroom CASH Joke",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Classroom setting. Teacher writes, 'महिलाएँ चाहती हैं Care Attention Support Honesty.' He points to letters and says, 'देखो, बनता है CASH.' Students laugh."
    }
  },
  {
    title: "Interview Comedy Punchline",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Stage interview. The interviewer asks, 'लड़की क्या नहीं भूलती?' The guest says, 'पड़ोस में दिए हुए बर्तन.' Audience laughs with energy."
    }
  },
  {
    title: "Buffalo Comedy Skit",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Farm setup. A man says to a buffalo, 'सॉरी राजजो, आज भुसा डालना भूल गया.' Cut to buffalo close up with a funny voice line, 'कोई बात नहीं, आज दूध की जगह मूत मिलेगा.' Man reacts in shock."
    }
  },
  {
    title: "Rural Comedy Interview",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Interview stage with a village guest. He says, 'लड़की बोलती है I have a boyfriend, लड़का बोलता है I am single. फिर लड़की पट्टा कौन रहा है?' Audience laughs loudly."
    }
  },
  {
    title: "Clinic Flirty Comedy Scene",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Clinic setting. A woman doctor checks a man's pulse. He looks at her with strong interest. She smiles and says, 'तेरी तबीयत नहीं, नीयत खराब है.' Scene feels playful and funny."
    }
  },
  {
    title: "Motivational Podcast Clip",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Podcast setup. A man speaks into the mic with energy. He says, 'मेहनत करते रहो भाई, तू एक दिन खुद ही हार मान जाएगा. ऐसी बातें सुनने के लिए मुझे follow करें.' Tone is strong and confident."
    }
  },
  {
    title: "Hindi Interview Scene",
    content: {
      "scene": 1,
      "duration": 7,
      "prompt": "Interview setup. A man interviews a young woman. He asks, 'आपका कोई boyfriend है?' She smiles and answers, 'हाँ है, पर breakup हो गया.' He asks, 'क्यों?' She replies, 'मैंने उसको दिल दिया, उसको दिमाग चाहिए था.' Both react with light humor."
    }
  },
  {
    title: "Crate Opening Assembly, Style 2",
    content: {
      "description": "A photorealistic sequence set in a clean futuristic showroom. A branded crate rests in the center under soft light. It vibrates then unlocks with a click. The crate opens and smooth energy bursts outward. Components lift and assemble mid air with clean motion. No text appears.",
      "style": "photorealistic cinematic minimalism",
      "camera": "Starts with a slow push in, orbits as panels open, then shifts to a top down view for assembly",
      "lighting": "Controlled ambient lights with soft spot highlights and neutral tones",
      "environment": "Minimal futuristic space with smooth surfaces and light reflections",
      "elements": [
        "{{BRAND_NAME}} crate",
        "{{PRIMARY_PRODUCT}}",
        "{{SECONDARY_ELEMENTS}}",
        "{{SUPPORTING_PROPS}}",
        "floating display stand",
        "soft ambient particles"
      ],
      "motion": "Crate unlocks with a click. Panels open. Components rise and assemble with smooth motion.",
      "ending": "{{PRODUCT_NAME}} sits on a glowing base and rotates slowly under a spotlight.",
      "text": "none",
      "keywords": [
        "{{BRAND_NAME}}",
        "{{PRODUCT_NAME}}",
        "crate opening reveal",
        "floating parts",
        "premium design",
        "clean motion",
        "futuristic showroom",
        "cinematic",
        "no text"
      ]
    }
  },
  {
    title: "Crate Opening Assembly, Style 1",
    content: {
      "metadata": {
        "prompt_name": "[PRODUCT_NAME] Assembly Sequence",
        "base_style": "cinematic, photorealistic, 4K",
        "aspect_ratio": "16:9",
        "room_description": "A clean environment that matches the product theme and brand tone",
        "camera_setup": "Fixed wide angle shot for the full duration",
        "key_elements": [
          "A sealed box with [PRODUCT_NAME] branding"
        ],
        "assembled_elements": [
          "List all objects or final states that appear during assembly"
        ],
        "negative_prompts": [
          "no people",
          "no text overlays",
          "no unrelated objects",
          "no clutter",
          "no distracting music"
        ]
      },
      "timeline": [
        {
          "sequence": 1,
          "timestamp": "00:00-00:01",
          "action": "A sealed [PRODUCT_NAME] box sits in the center, still and quiet.",
          "audio": "Soft ambient tone matching the space."
        },
        {
          "sequence": 2,
          "timestamp": "00:01-00:02",
          "action": "The box shakes slightly as seams glow.",
          "audio": "A clear click or pop."
        },
        {
          "sequence": 3,
          "timestamp": "00:02-00:06",
          "action": "Assembled elements appear from the box and move into place.",
          "audio": "Clean whooshes, clicks, and light mechanical sounds."
        },
        {
          "sequence": 4,
          "timestamp": "00:06-00:08",
          "action": "The final piece settles. The full setup is now complete.",
          "audio": "A soft closing sound or quiet chime."
        }
      ]
    }
  },
  {
    title: "UGC Real-World Social Ad",
    content: {
      "description": "A vertical UGC style video. Hands hold the product while walking outside. Natural lighting and handheld movement create a real feel. Jump cuts and light ambient sounds make it relatable. Voice over speaks casually. Everyday settings like bedrooms, sidewalks, and cafes appear. Social style text overlays add clarity. Ends with the product in use and a simple call to action.",
      "visual_style": "Handheld vertical format with natural lighting and minimal edits",
      "camera_movement": "Selfie style movement, light shake, quick zooms",
      "mood": "Casual, real, friendly",
      "scene_transitions": "Jump cuts, swipe edits, selfie flip",
      "sound_design": "Ambient background sound, light upbeat music, voice over",
      "text_overlays": [
        "Tried It Myself",
        "Real Use Case",
        "You Should Try It"
      ]
    }
  },
  {
    title: "Premium Unboxing Experience",
    content: {
      "description": "An elegant unboxing sequence. Hands open the box in slow motion under soft studio lights. The product is revealed with subtle flares and floating dust particles. Gentle piano music sets a calm tone. Each unwrapping step is shown in tight close up. The final reveal places the product on a clean satin surface with a short premium callout.",
      "visual_style": "Soft studio setup with ambient lighting and macro detail",
      "camera_movement": "Overhead reveals, slow pans, light handheld realism",
      "mood": "Calm, premium, refined",
      "scene_transitions": "Soft dissolves, light leaks, slow fades",
      "sound_design": "Soft ambient music, light unwrapping sounds, gentle chime",
      "text_overlays": [
        "Pure Detail",
        "Premium Touch",
        "Made for You"
      ]
    }
  },
  {
    title: "Tech Product Demo Ad",
    content: {
      "description": "A cinematic demo that shows each feature in clear focus. UI style text appears beside the product. The product rotates in 3D. Close ups show texture, hands pressing buttons, and lights activating. Clean cool background with floating particles. Cool tone grading and soft synth music. Ends with a sharp value line and the brand logo.",
      "visual_style": "Modern product showcase with reflective surfaces and sharp detail",
      "camera_movement": "360 spins, tilt up reveals, tight macro zooms",
      "mood": "Clean, sleek, tech focused",
      "scene_transitions": "Glitch wipes, fast zoom cuts, digital transitions",
      "sound_design": "Soft synth tones, clicks, power up hum",
      "text_overlays": [
        "Smart Design",
        "Key Features",
        "Now Shipping"
      ]
    }
  },
  {
    title: "Foodie Cravings Ad",
    content: {
      "description": "A crave-focused food spot with close-up shots of rich textures, rising steam, and sizzling details. Warm lighting highlights each ingredient. Slow motion cheese pulls, bubbling sauce, crisp crust cracking, and garnish sprinkling create appetite appeal. Natural kitchen background with golden tones. Ends with a plated dish and a short call to action.",
      "visual_style": "High frame rate food shots with shallow focus, warm tones, macro details",
      "camera_movement": "Slow pans, tight zooms on texture, overhead and side shots",
      "mood": "Crave focused, warm, inviting",
      "scene_transitions": "Fade ins with steam or sauce motion",
      "sound_design": "ASMR style cooking sounds including sizzling, crunch, pouring",
      "text_overlays": [
        "Made to Crave",
        "Taste the Hype",
        "Ready to Serve"
      ]
    }
  },
  {
    title: "Cinematic Product Commercial",
    content: {
      "description": "A dramatic cinematic commercial that shows the product as a major shift in its category. Epic landscape shots, sweeping drone angles, and intense lighting set the tone. Slow motion reveals the product in a rich environment. Color grading uses strong contrast with warm highlights. Ambient cinematic music builds tension. Text overlays appear between scenes. The ad ends with a close-up hero shot and a clean fade-out.",
      "visual_style": "Movie trailer look with deep contrast, lens flares, cinematic depth of field, slow motion scenes",
      "camera_movement": "Smooth dolly in shots, wide tracking shots, aerial pans",
      "mood": "Epic, emotional, inspiring",
      "scene_transitions": "Cinematic dissolves, time-lapse cuts, flare cuts",
      "sound_design": "Orchestral soundtrack with subtle whoosh and rise effects",
      "text_overlays": [
        "Change Starts Here",
        "Built to Impress",
        "Available Now"
      ]
    }
  },
  {
    title: "IKEA Room Auto Assembly",
    content: {
      "prompt_name": "IKEA Empty Room Assembly",
      "base_style": "cinematic, photorealistic, 4K",
      "aspect_ratio": "16:9",
      "room_description": "A large Scandinavian room with white walls and light wood floors. Sunlight fills the space. The room is empty.",
      "camera_setup": "One fixed wide shot. No camera movement for eight seconds.",
      "key_elements": [
        "sealed IKEA box with logo visible"
      ],
      "assembled_elements": [
        "bed with white duvet",
        "yellow IKEA throw blanket",
        "bedside tables",
        "lamps",
        "wardrobe",
        "shelves",
        "mirror",
        "art",
        "rug",
        "curtains",
        "potted plants"
      ],
      "negative_prompts": [
        "no people",
        "no text overlays",
        "no distracting music"
      ],
      "timeline": [
        {
          "sequence": 1,
          "timestamp": "00:00-00:01",
          "action": "A sealed IKEA box sits in the center of the empty room. It trembles lightly.",
          "audio": "Low rumble in a wide empty room."
        },
        {
          "sequence": 2,
          "timestamp": "00:01-00:02",
          "action": "The box seams burst open with a small cloud of cardboard dust.",
          "audio": "Sharp pop and tearing cardboard."
        },
        {
          "sequence": 3,
          "timestamp": "00:02-00:06",
          "action": "Hyper lapse. Furniture parts shoot out of the box and assemble into each item from the list. All motion stays within the fixed wide frame.",
          "audio": "Fast ASMR clicks, whirs, and wood snaps."
        },
        {
          "sequence": 4,
          "timestamp": "00:06-00:08",
          "action": "The yellow throw blanket drifts down onto the bed. The room is fully furnished and still.",
          "audio": "All sounds stop. Soft fwoomp as the blanket lands."
        }
      ]
    }
  },
  {
    title: "Rolex Precision Build",
    content: {
      "title": "Rolex Precision Build",
      "style": "cinematic luxury, mechanical detail, dark studio look",
      "sequence": [
        {
          "stage": "studio_logo_reveal",
          "description": "A black studio. The golden Rolex crown fades in at center. The letters R O L E X light up under it. Each letter glows with a short shimmer. A soft pulse of light and sound moves through the room.",
          "camera": {
            "movement": "slow push in with a small rotation",
            "framing": "centered crown and lettering in crisp focus"
          },
          "lighting": "spotlight from above with edge glow",
          "sound_effects": "low ambient tone, light ticking"
        },
        {
          "stage": "logo_to_mechanics",
          "description": "The letters shift and open into small mechanical parts. Springs, gears, bezels, rotors, and dial pieces float upward. The crown forms the center rotor. Everything holds in weightless motion.",
          "camera": {
            "movement": "rotating dolly around floating parts",
            "framing": "balanced view of the suspended assembly"
          },
          "effects": [
            "slow transitions",
            "reflective metal look",
            "gold and steel highlights"
          ],
          "sound_effects": "soft ticks, gear turns, rising tone"
        },
        {
          "stage": "magnetic_assembly",
          "description": "Parts slide into position with magnetic pull. Core mechanics lock first, then bezel, dial, case, and strap. The winding crown turns slightly and clicks into place.",
          "camera": {
            "movement": "orbital sweep with angle shifts",
            "framing": "central focus with close detail shots"
          },
          "effects": [
            "gear mesh animation",
            "clean chrome finish",
            "light bloom on edges"
          ],
          "sound_effects": "sharp clicks, tight snaps, soft chime"
        },
        {
          "stage": "watch_reveal_finale",
          "description": "The finished Rolex rotates in mid air. Studio lights trace across steel and gold surfaces. A beam highlights the dial. The camera circles the watch with a rising tilt.",
          "camera": {
            "movement": "full orbit with upward tilt",
            "framing": "hero shot with smooth motion"
          },
          "effects": [
            "rim light glow",
            "subtle lens flare",
            "gold spark detail"
          ],
          "sound_effects": "clean swoosh, steady ticking, calm tone"
        }
      ],
      "mood": "precision engineering and premium craft",
      "color_palette": "black, gold, steel, soft emerald",
      "style_reference": "cinematic engineering showcase"
    }
  }
];